/*** IMPORTS FROM imports-loader ***/
var define = false;

import createPredicateIndexFinder from './_createPredicateIndexFinder.js';

// Returns the first index on an array-like that passes a truth test.
export default createPredicateIndexFinder(1);




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/findIndex.js
// module id = 34
// module chunks = 0